    (function () {
        function getDrawer() {
            return document.querySelector('.bh-drawer');
        }

        document.addEventListener(
            'click',
            function (e) {
                const cartBtn = e.target.closest('#cart-icon-bubble');
                const closeBtn = e.target.closest('[data-close]');

                const drawer = getDrawer();
                if (!drawer) return;

                // OPEN
                if (cartBtn) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    drawer.classList.add('is-open');
                    document.documentElement.classList.add('bh-lock');
                    return;
                }

                // CLOSE
                if (closeBtn) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    drawer.classList.remove('is-open');
                    document.documentElement.classList.remove('bh-lock');
                }
            },
            true
        );

        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape') return;
            const drawer = getDrawer();
            if (!drawer) return;
            drawer.classList.remove('is-open');
            document.documentElement.classList.remove('bh-lock');
        });
    })();

    // cart ajax update 

    (function () {
        if (window.__BH_GLOBAL_ATC_HOOK__) return;
        window.__BH_GLOBAL_ATC_HOOK__ = true;

        function isBuyNowSubmit(submitter, form) {
            try {
                if (submitter) {
                    const cls = submitter.className || '';
                    if (
                        submitter.name === 'checkout' ||
                        submitter.value === 'checkout' ||
                        cls.includes('shopify-payment-button') ||
                        submitter.closest('.shopify-payment-button')
                    ) return true;
                }
                const rt = form && form.querySelector('input[name="return_to"]');
                if (rt && rt.value && rt.value.includes('/checkout')) return true;
            } catch (e) { }
            return false;
        }

        let lock = false;
        async function runAdd(form) {
            if (lock) return;
            lock = true;

            try {
                const fd = new FormData(form);
                const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
                if (!res.ok) throw new Error('add failed');

                if (window.BH_CART_OPEN_AND_REFRESH) await window.BH_CART_OPEN_AND_REFRESH();
                else document.dispatchEvent(new CustomEvent('bh:cart-updated'));
            } catch (e) {
                console.error(e);
                window.location.href = '/cart';
            } finally {
                setTimeout(() => { lock = false; }, 400);
            }
        }

        document.addEventListener('submit', function (e) {
            const form = e.target;
            if (!form || !form.action) return;
            if (!/\/cart\/add/i.test(form.action)) return;

            const submitter = e.submitter || document.activeElement;
            if (isBuyNowSubmit(submitter, form)) return;

            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();

            runAdd(form);
        }, true);
    })();
    // cart ajax update end


    // BH Product Focus
    (function () {
        const root = document.querySelector('[data-bhp]');
        if (!root) return;

        const wrap = root.querySelector('.bhp__wrap');
        if (!wrap) return;

        const variants = JSON.parse(wrap.getAttribute('data-variants') || '[]');
        const options = JSON.parse(wrap.getAttribute('data-options') || '[]');

        const imgEl = root.querySelector('[data-main-img]');
        const priceEl = root.querySelector('[data-price]');
        const idInput = root.querySelector('[data-variant-id]');
        const atcBtn = root.querySelector('[data-atc]');
        const form = root.querySelector('form.bhp__form');

        const swWrap = root.querySelector('[data-opt="color"]');
        const szWrap = root.querySelector('[data-opt="size"]');
        const colorLabel = root.querySelector('[data-color-label]');

        const optIndexColor = swWrap ? Number(swWrap.getAttribute('data-opt-index')) : null;
        const optIndexSize = szWrap ? Number(szWrap.getAttribute('data-opt-index')) : null;

        if (swWrap) swWrap.style.visibility = 'hidden';
        if (szWrap) szWrap.style.visibility = 'hidden';
        if (colorLabel) colorLabel.style.visibility = 'hidden';

        const SWATCH_MAP = {
            'noir': '#000000',
            'bordeaux': '#5a272e',
            'vintage noir': '#1a1a1a',
            'washed black': '#1a1a1a',
            'navy': '#161527',
            'brown': '#594338',
            'plum': '#513c4f',
            'olive': '#61553e',
            'khaki': '#83794d',
            'beige': '#d7c8ae',
            'off white': '#e7e4db',
            'white': '#ffffff',
            'light gray': '#dcdcdc',
            'light blue': '#b5cff2',
            'peach': '#f2cac4',
            'red': '#b73234',
            'blue': '#215297',
            'yellow': '#edba44'
        };

        const normalize = (v) => String(v || '').trim().toLowerCase().replace(/\s+/g, ' ');

        const STORAGE_KEY = `bhp_sel_${wrap.getAttribute('data-url') || ''}_${root.closest('section')?.id || ''}`;

        function saveSelection(sel) {
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify({
                    color: sel.color || null,
                    size: sel.size || null
                }));
            } catch (e) { }
        }

        function loadSelection() {
            try {
                return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
            } catch (e) {
                return {};
            }
        }

        function moneyFromCents(cents) {
            try {
                return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
            } catch (e) {
                return '$' + (cents / 100).toFixed(2);
            }
        }

        function slug(v) {
            return String(v || '')
                .trim().toLowerCase()
                .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '');
        }

        function paintSwatches() {
            if (!swWrap) return;

            swWrap.querySelectorAll('.bhp__swatch').forEach(btn => {
                const raw = btn.getAttribute('data-value') || '';
                const s = slug(raw);
                const dot = btn.querySelector('[data-swatch]');
                if (!dot) return;

                const cssVar = `--swatch-${s}`;
                const fromCss = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();

                const key = normalize(raw);
                dot.style.setProperty('--swatch', fromCss || SWATCH_MAP[key] || '#ddd');
            });
        }

        function findVariantExact(selected) {
            return variants.find(v => v.options.every((opt, i) => opt === selected[i]));
        }

        function getSelected() {
            const sel = new Array(options.length).fill(null);
            const base = variants.find(v => v.available)?.options || variants[0]?.options || [];

            for (let i = 0; i < sel.length; i++) sel[i] = base[i] || null;

            const activeSw = root.querySelector('.bhp__swatch.is-active');
            const activeSz = root.querySelector('.bhp__size.is-active');

            if (swWrap && optIndexColor !== null) {
                sel[optIndexColor] = activeSw ? activeSw.getAttribute('data-value') : sel[optIndexColor];
            }
            if (szWrap && optIndexSize !== null) {
                sel[optIndexSize] = activeSz ? activeSz.getAttribute('data-value') : sel[optIndexSize];
            }
            return sel;
        }

        function syncAvailability() {
            if (!szWrap || optIndexSize === null) return;

            const sel = getSelected();
            const selectedColor = (optIndexColor !== null) ? sel[optIndexColor] : null;

            const possible = new Set();
            variants.forEach(v => {
                if (!v.available) return;
                if (optIndexColor !== null && selectedColor && v.options[optIndexColor] !== selectedColor) return;
                possible.add(v.options[optIndexSize]);
            });

            const sizeBtns = szWrap.querySelectorAll('.bhp__size');
            sizeBtns.forEach(btn => {
                const val = btn.getAttribute('data-value');
                const ok = possible.has(val);
                btn.classList.toggle('is-disabled', !ok);
                btn.disabled = !ok;
                btn.setAttribute('aria-disabled', (!ok).toString());
            });

            const active = szWrap.querySelector('.bhp__size.is-active');
            if (active && active.disabled) {
                const firstOk = Array.from(sizeBtns).find(b => !b.disabled);
                if (firstOk) {
                    sizeBtns.forEach(b => b.classList.remove('is-active'));
                    firstOk.classList.add('is-active');
                }
            }
        }

        function syncUI() {
            const sel = getSelected();
            const v = findVariantExact(sel) || variants.find(x => x.available) || variants[0];
            if (!v) return;

            if (idInput) idInput.value = v.id;
            if (priceEl) {
  const formatted = moneyFromCents(v.price);
  priceEl.textContent = formatted.replace(/(\.\d{2})$/, '');
}

            if (atcBtn) {
                atcBtn.disabled = !v.available;
                atcBtn.textContent = v.available ? 'add to bag' : 'sold out';
            }

            if (colorLabel && optIndexColor !== null) {
                colorLabel.textContent = (sel[optIndexColor] || v.options[optIndexColor] || '').toLowerCase();
            }

            if (imgEl) {
                const src = v.featured_image && v.featured_image.src ? v.featured_image.src : imgEl.src;
                if (src) imgEl.src = src;
            }

            syncAvailability();
        }

        function setActiveDefaults() {
            const firstAvailable = variants.find(v => v.available) || variants[0];
            if (!firstAvailable) return;

            const saved = loadSelection();

            if (swWrap && optIndexColor !== null) {
                const want = saved.color || firstAvailable.options[optIndexColor];
                swWrap.querySelectorAll('.bhp__swatch').forEach(b => {
                    b.classList.toggle('is-active', normalize(b.getAttribute('data-value')) === normalize(want));
                });
            }

            if (szWrap && optIndexSize !== null) {
                const want = saved.size || firstAvailable.options[optIndexSize];
                szWrap.querySelectorAll('.bhp__size').forEach(b => {
                    b.classList.toggle('is-active', normalize(b.getAttribute('data-value')) === normalize(want));
                });
            }

            syncUI();


            if (swWrap) swWrap.style.visibility = '';
            if (szWrap) szWrap.style.visibility = '';
            if (colorLabel) colorLabel.style.visibility = '';
        }

        root.addEventListener('click', (e) => {
            const sw = e.target.closest('.bhp__swatch');
            if (sw) {
                e.preventDefault();
                swWrap.querySelectorAll('.bhp__swatch').forEach(x => x.classList.remove('is-active'));
                sw.classList.add('is-active');
                syncUI();
                saveSelection({
                    color: sw.getAttribute('data-value'),
                    size: root.querySelector('.bhp__size.is-active')?.getAttribute('data-value') || null
                });
                return;
            }

            const sz = e.target.closest('.bhp__size');
            if (sz) {
                e.preventDefault();
                if (sz.disabled) return;
                szWrap.querySelectorAll('.bhp__size').forEach(x => x.classList.remove('is-active'));
                sz.classList.add('is-active');
                syncUI();
                saveSelection({
                    color: root.querySelector('.bhp__swatch.is-active')?.getAttribute('data-value') || null,
                    size: sz.getAttribute('data-value')
                });
            }
        });

        if (form) {
            form.addEventListener('submit', async (e) => {
                e.preventDefault();
                if (!idInput) return;

                atcBtn && (atcBtn.disabled = true);

                try {
                    let prevCount = null;
                    try {
                        const c = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(r => r.json());
                        prevCount = Number(c.item_count || 0);
                        if (window.BH_DEBUG) console.log('[BHP]', 'prevCount', prevCount);
                    } catch (ex) { }

                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ id: Number(idInput.value), quantity: 1 })
                    });

                    document.dispatchEvent(new CustomEvent('bh:cart-updated'));
                    if (window.BH_CART_OPEN_AND_REFRESH) {
                        await window.BH_CART_OPEN_AND_REFRESH();
                    } else if (window.BH_REFRESH_DRAWER) {
                        await window.BH_REFRESH_DRAWER();
                    } else {
                        window.location.href = '/cart';
                    }

                } catch (err) {
                    console.error(err);
                    window.location.href = '/cart';
                } finally {
                    syncUI();
                    atcBtn && (atcBtn.disabled = false);
                }
            });
        }

        paintSwatches();
        setActiveDefaults();
    })();

    // BH Product Focus end



    // Cart Drawer All js

    (() => {
        const DRAWER_ID = 'bh-cart-drawer';
        const OPEN_CLASS = 'is-open';
        const LOCK_CLASS = 'bh-lock';

        const SWATCH_MAP = {
            'noir': '#000000',
            'washed black': '#1a1a1a',
            'vintage noir': '#1a1a1a',
            'bordeaux': '#5a272e',
            'navy': '#161527',
            'brown': '#594338',
            'plum': '#513c4f',
            'olive': '#61553e',
            'khaki': '#83794d',
            'beige': '#d7c8ae',
            'off white': '#e7e4db',
            'white': '#ffffff',
            'light gray': '#dcdcdc',
            'light blue': '#b5cff2',
            'peach': '#f2cac4',
            'red': '#b73234',
            'blue': '#215297',
            'yellow': '#edba44',
        };

        const normalize = (v) => String(v || '').trim().toLowerCase().replace(/\s+/g, ' ');
        const qs = (s, r = document) => r.querySelector(s);
        const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

        function slug(v) {
            return String(v || '')
                .trim().toLowerCase()
                .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '');
        }

        function getDrawer() { return qs(`#${DRAWER_ID}`); }

        function lock(on) {
            document.documentElement.classList.toggle(LOCK_CLASS, !!on);
        }


        function openDrawer() {
            const d = getDrawer();
            if (!d) return;

            d.setAttribute('aria-hidden', 'false');
            lock(true);

            d.classList.remove(OPEN_CLASS);
            void d.offsetWidth;

            requestAnimationFrame(() => {
                d.classList.add(OPEN_CLASS);
            });
        }


        function keepDrawerOpenNoAnim() {
            const d = getDrawer();
            if (!d) return;
            d.setAttribute('aria-hidden', 'false');
            d.classList.add(OPEN_CLASS);
            lock(true);
        }

        function closeDrawer() {
            const d = getDrawer();
            if (!d) return;
            d.classList.remove(OPEN_CLASS);
            d.setAttribute('aria-hidden', 'true');
            lock(false);
        }

        async function getCart() {
            const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
            return r.json();
        }

        function startUpdating() {
            const d = getDrawer();
            if (!d) return;
            d.classList.add('is-updating');
        }
        function stopUpdating() {
            const d = getDrawer();
            if (!d) return;
            requestAnimationFrame(() => d.classList.remove('is-updating'));
        }

        function animateRemoveRow(btn) {
            const row = btn.closest('.bhCart__itemRow');
            if (!row) return Promise.resolve();

            if (row.classList.contains('is-removing')) return Promise.resolve();
            row.classList.add('is-removing');

            const h = row.offsetHeight;
            row.style.height = h + 'px';
            row.style.overflow = 'hidden';
            row.style.willChange = 'height, opacity, transform';
            row.style.transition = 'height .28s ease, opacity .28s ease, transform .28s ease, margin .28s ease, padding .28s ease';

            requestAnimationFrame(() => {
                row.style.opacity = '0';
                row.style.transform = 'translateX(10px)';
                row.style.height = '0px';
                row.style.marginTop = '0';
                row.style.marginBottom = '0';
                row.style.paddingTop = '0';
                row.style.paddingBottom = '0';
            });

            return new Promise(res => setTimeout(res, 290));
        }

        async function refreshDrawerHTML() {
            const root = qs('[data-bh-cart-root]');
            if (!root) return;

            const handle = root.getAttribute('data-section-handle');
            if (!handle) return;

            const drawerBefore = getDrawer();
            const wasOpen = !!drawerBefore?.classList.contains(OPEN_CLASS);


            if (wasOpen) keepDrawerOpenNoAnim();

            startUpdating();

            const url = new URL(window.location.origin + '/');
            url.searchParams.set('section_id', handle);

            const r = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
            if (!r.ok) { stopUpdating(); return; }

            const html = await r.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');

            const nextRoot = doc.querySelector('[data-bh-cart-root]');
            const curRoot = qs('[data-bh-cart-root]');


            if (wasOpen && nextRoot) {
                const nextDrawer = nextRoot.querySelector(`#${DRAWER_ID}`);
                if (nextDrawer) {
                    nextDrawer.classList.add(OPEN_CLASS);
                    nextDrawer.setAttribute('aria-hidden', 'false');
                }
            }

            if (nextRoot && curRoot) curRoot.replaceWith(nextRoot);


            if (wasOpen) keepDrawerOpenNoAnim();

            paintDrawerSwatches();
            syncBagDot();
            setupVariantUI();
            stopUpdating();
        }

        function syncBagDot() {
            const bubble = qs('#cart-icon-bubble');
            if (!bubble) return;

            getCart().then(cart => {
                bubble.classList.toggle('is-filled', (cart.item_count || 0) > 0);
            }).catch(() => { });
        }

        function paintDrawerSwatches() {
            const d = getDrawer();
            if (!d) return;

            const ui = qs('[data-bh-variant-ui]', d);
            if (!ui) return;

            qsa('[data-bh-swatch]', ui).forEach(dot => {
                const btn = dot.closest('button');
                const raw = btn?.getAttribute('data-bh-value') || '';
                const n = normalize(raw);

                if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(n)) {
                    dot.style.setProperty('--swatch', n);
                    return;
                }

                const cssVar = `--swatch-${slug(raw)}`;
                const fromCss = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();

                dot.style.setProperty('--swatch', fromCss || SWATCH_MAP[n] || '#ddd');
            });
        }

        function findVariantExact(variants, selected) {
            return variants.find(v => v.options.every((opt, i) => opt === selected[i]));
        }

        function setupVariantUI() {
            const d = getDrawer();
            if (!d) return;

            const ui = qs('[data-bh-variant-ui]', d);
            if (!ui) return;

            let variants = [];
            let options = [];
            try {
                variants = JSON.parse(ui.getAttribute('data-variants') || '[]');
                options = JSON.parse(ui.getAttribute('data-options') || '[]');
            } catch (e) { return; }

            const swWrap = qs('[data-bh-opt="color"]', ui);
            const szWrap = qs('[data-bh-opt="size"]', ui);

            const idxColor = swWrap ? Number(swWrap.getAttribute('data-bh-opt-index')) : null;
            const idxSize = szWrap ? Number(szWrap.getAttribute('data-bh-opt-index')) : null;

            function getSelected() {
                const base = variants.find(v => v.available)?.options || variants[0]?.options || [];
                const sel = new Array(options.length).fill(null).map((_, i) => base[i] || null);

                const aSw = qs('.bhCart__swatch.is-active', ui);
                const aSz = qs('.bhCart__size.is-active', ui);

                if (swWrap && idxColor !== null) sel[idxColor] = aSw ? aSw.getAttribute('data-bh-value') : sel[idxColor];
                if (szWrap && idxSize !== null) sel[idxSize] = aSz ? aSz.getAttribute('data-bh-value') : sel[idxSize];

                return sel;
            }

            function syncAvailability() {
                if (!szWrap || idxSize === null) return;

                const sel = getSelected();
                const selectedColor = (idxColor !== null) ? sel[idxColor] : null;

                const possible = new Set();
                variants.forEach(v => {
                    if (!v.available) return;
                    if (idxColor !== null && selectedColor && v.options[idxColor] !== selectedColor) return;
                    possible.add(v.options[idxSize]);
                });

                qsa('.bhCart__size', szWrap).forEach(btn => {
                    const v = btn.getAttribute('data-bh-value');
                    const ok = possible.has(v);
                    btn.classList.toggle('is-disabled', !ok);
                    btn.disabled = !ok;
                });

                const active = qs('.bhCart__size.is-active', szWrap);
                if (active && active.disabled) {
                    const firstOk = qsa('.bhCart__size', szWrap).find(b => !b.disabled);
                    if (firstOk) {
                        qsa('.bhCart__size', szWrap).forEach(b => b.classList.remove('is-active'));
                        firstOk.classList.add('is-active');
                    }
                }
            }


            function syncVariantText() {
                const sel = getSelected();

                const colorEl = qs('[data-bh-color-name]', ui);
                if (colorEl && idxColor !== null) {
                    const c = sel[idxColor] || '';
                    colorEl.textContent = String(c).toLowerCase();
                }

                syncAvailability();
            }

            function setDefaults() {
                const first = variants.find(v => v.available) || variants[0];
                if (!first) return;

                if (swWrap && idxColor !== null) {
                    const want = first.options[idxColor];
                    qsa('.bhCart__swatch', swWrap).forEach(b => {
                        b.classList.toggle('is-active', b.getAttribute('data-bh-value') === want);
                    });
                }
                if (szWrap && idxSize !== null) {
                    const want = first.options[idxSize];
                    qsa('.bhCart__size', szWrap).forEach(b => {
                        b.classList.toggle('is-active', b.getAttribute('data-bh-value') === want);
                    });
                }
                syncVariantText();
                paintDrawerSwatches();
            }

            ui.addEventListener('click', (e) => {
                const sw = e.target.closest('.bhCart__swatch');
                if (sw && swWrap) {
                    e.preventDefault();
                    qsa('.bhCart__swatch', swWrap).forEach(x => x.classList.remove('is-active'));
                    sw.classList.add('is-active');
                    syncVariantText();
                    return;
                }

                const sz = e.target.closest('.bhCart__size');
                if (sz && szWrap) {
                    e.preventDefault();
                    if (sz.disabled) return;
                    qsa('.bhCart__size', szWrap).forEach(x => x.classList.remove('is-active'));
                    sz.classList.add('is-active');
                    syncVariantText();
                }
            });

            const addBtn = qs('[data-bh-add-variant]', ui);
            if (addBtn) {
                addBtn.addEventListener('click', async (e) => {
                    e.preventDefault();

                    const sel = getSelected();
                    const v = findVariantExact(variants, sel);
                    if (!v) return;

                    try {
                        await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                            body: JSON.stringify({ id: Number(v.id), quantity: 1 })
                        });

                        await refreshDrawerHTML();
                        keepDrawerOpenNoAnim();
                    } catch (err) {
                        window.location.href = '/cart';
                    }
                });
            }

            setDefaults();
        }

        document.addEventListener('click', (e) => {
            const closeBtn = e.target.closest('[data-bh-close]');
            if (closeBtn) {
                e.preventDefault();
                closeDrawer();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeDrawer();
        });


        document.addEventListener('click', async (e) => {
            const cartBtn = e.target.closest('#cart-icon-bubble');
            if (!cartBtn) return;

            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

            await refreshDrawerHTML();
            openDrawer();
        }, true);


        document.addEventListener('click', async (e) => {
            const btn = e.target.closest('[data-bh-remove]');
            if (!btn) return;

            e.preventDefault();

            const key = btn.getAttribute('data-line-key');
            if (!key) return;

            try {
                await animateRemoveRow(btn);

                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: key, quantity: 0 })
                });

                await refreshDrawerHTML();
                keepDrawerOpenNoAnim();
            } catch (err) {
                window.location.href = '/cart';
            }
        });


        window.BH_CART_OPEN_AND_REFRESH = async function () {
            await refreshDrawerHTML();
            openDrawer();
        };

        document.addEventListener('bh:cart-updated', async () => {
            await refreshDrawerHTML();
            openDrawer();
        });


        syncBagDot();
        paintDrawerSwatches();
        setupVariantUI();
    })();

    // Cart Drawer All js end